// extracted by mini-css-extract-plugin
export default {"detailBox":"detailBox__1Y29d","detailBoxTitle":"detailBoxTitle__1cucm","detailBoxDescription":"detailBoxDescription__LD1cJ","imageBlock":"imageBlock__m6d7y"};